import React from "react";
import classes from "./classes.module.scss";
import Typography, { ETypo } from "@Front/Components/DesignSystem/Typography";
import Form from "@Front/Components/DesignSystem/Form";
import TextField from "@Front/Components/DesignSystem/Form/TextField";
import Button, { EButtonVariant } from "@Front/Components/DesignSystem/Button";
import { ValidationError } from "class-validator";
import { useStepPasswordCopy } from "./useStepPasswordCopy";
import { StepPasswordForgotModal } from "./StepPasswordForgotModal";
import SiteConfigDisplayNameLine from "@Front/Components/Layouts/Common/SiteConfigDisplayNameLine";
import { useStepPasswordModalState } from "./useStepPasswordModalState";

type IProps = {
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	onPasswordForgotClicked: () => void;
	siteDisplayName: string | null;
};

export default function StepPassword(props: IProps): React.JSX.Element {
	const { onSubmit, validationErrors, onPasswordForgotClicked, siteDisplayName } = props;
	const copy = useStepPasswordCopy();
	const { isModalOpened, closeModal, openModal, onModalAccept } = useStepPasswordModalState(onPasswordForgotClicked);

	return (
		<div className={classes["root"]}>
			<Typography typo={ETypo.DISPLAY_LARGE}>
				<div className={classes["title"]}>{copy.formTitle}</div>
			</Typography>
			<SiteConfigDisplayNameLine siteDisplayName={siteDisplayName} />
			<Form className={classes["form"]} onSubmit={onSubmit}>
				<TextField
					placeholder={copy.passwordPlaceholder}
					name="password"
					validationError={validationErrors.find((error) => error.property === "password")}
					password
				/>
				<button type="button" className={classes["forgot-password-trigger"]} onClick={openModal}>
					<Typography typo={ETypo.TEXT_MD_REGULAR} className={classes["forgot-password"]}>
						{copy.passwordForgottenLink}
					</Typography>
				</button>
				<Button type="submit" variant={EButtonVariant.PRIMARY} className={classes["submit_button"]}>
					{copy.formSubmitCta}
				</Button>
			</Form>
			<StepPasswordForgotModal
				isOpen={isModalOpened}
				onClose={closeModal}
				onConfirm={onModalAccept}
				copy={copy}
			/>
		</div>
	);
}
